import type { RouteRecordRaw } from 'vue-router';
import rystIncentivesManagerRoute, {
  locationUserManagementRoute,
  promoManagementRoute,
} from '../components/ryst-incentives-manager';
import { createRoute } from './create/create';
import { listRoute } from './list/list';
import { updateRoute } from './update/update';

// Register before `:id` (update) so this path is not matched as a discount id.
const childRoutes: RouteRecordRaw[] = [
  listRoute,
  createRoute,
  rystIncentivesManagerRoute,
  locationUserManagementRoute,
  promoManagementRoute,
  updateRoute,
];

export default childRoutes;
